import { render, staticRenderFns } from "./DaftarVoidGadai.vue?vue&type=template&id=68f6d162&"
import script from "./DaftarVoidGadai.vue?vue&type=script&lang=js&"
export * from "./DaftarVoidGadai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports